var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_10294)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54676 6.54692C7.97631 5.11736 10.1088 4.5778 12.8332 4.5778H19.1665C21.8909 4.5778 24.0234 5.11736 25.453 6.54692C26.8825 7.97647 27.4221 10.109 27.4221 12.8334V19.1667C27.4221 21.8911 26.8825 24.0236 25.453 25.4531C24.0234 26.8827 21.8909 27.4222 19.1665 27.4222H12.8332C10.1088 27.4222 7.97631 26.8827 6.54676 25.4531C5.1172 24.0236 4.57764 21.8911 4.57764 19.1667V12.8334C4.57764 10.109 5.1172 7.97647 6.54676 6.54692ZM7.77241 7.77257C6.82696 8.71801 6.31097 10.2799 6.31097 12.8334V19.1667C6.31097 21.7201 6.82696 23.282 7.77241 24.2275C8.71785 25.1729 10.2798 25.6889 12.8332 25.6889H19.1665C21.7199 25.6889 23.2819 25.1729 24.2273 24.2275C25.1728 23.282 25.6887 21.7201 25.6887 19.1667V12.8334C25.6887 10.2799 25.1728 8.71801 24.2273 7.77257C23.2819 6.82712 21.7199 6.31113 19.1665 6.31113H12.8332C10.2798 6.31113 8.71785 6.82712 7.77241 7.77257ZM8.84473 20.4858C8.99644 20.0318 9.48744 19.7868 9.9414 19.9385C13.8692 21.2511 18.1308 21.2511 22.0587 19.9385C22.5126 19.7868 23.0036 20.0318 23.1554 20.4858C23.3071 20.9397 23.062 21.4307 22.6081 21.5824C18.3237 23.0142 13.6764 23.0142 9.39201 21.5824C8.93804 21.4307 8.69301 20.9397 8.84473 20.4858ZM16 9.33821C16.4786 9.33821 16.8666 9.72623 16.8666 10.2049V16.5569L18.5538 14.8697C18.8923 14.5313 19.441 14.5313 19.7795 14.8697C20.1179 15.2082 20.1179 15.7569 19.7795 16.0954L16.6209 19.2539C16.4635 19.4156 16.2434 19.516 16 19.516C15.7565 19.516 15.5365 19.4156 15.379 19.2539L12.2205 16.0954C11.882 15.7569 11.882 15.2082 12.2205 14.8697C12.5589 14.5313 13.1077 14.5313 13.4461 14.8697L15.1333 16.5569V10.2049C15.1333 9.72623 15.5213 9.33821 16 9.33821Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_10294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowDown);
export default __webpack_public_path__ + "static/media/downloadArrowDown.00c5022d.svg";
export { ForwardRef as ReactComponent };